module.exports = __webpack_public_path__ + "img/home-app-image-cn.2f1fa62e.png";